// Custom
import * as $ from 'jquery';
import 'inputmask';
import { noty_render_alert } from 'common/noty_notifications';
import DatePicker from 'new_design/common/search_widget/date-picker';
import { iti_config, phone_settings, safeInitIntlTelInput } from 'new_design/common/intl_tel_input_config'
import * as menu from '@material/menu/index';
import {MTUIGetElement, MTUIOnInit} from "../common/mtui/mtui";
import {textFieldsInit} from "../common/mtui/text_field";
import { clearClientFormData, syncClientFormData } from '../../features/client_form_data';

window.execCaptcha = function () {
  if (!window.smartCaptcha) {
    document.getElementsByClassName('booking-form main-form')[0].submit();
    return false;
  }
  window.smartCaptcha.execute();
  return true;
}

window.passedCaptcha = function () {
  const token = document.getElementsByName('smart-token')[0];
  if (token) {
    clearClientFormData();
    document.getElementById('captcha-token').value = token.value;
    document.getElementsByClassName('booking-form main-form')[0].submit();
    return true;
  } else {
    return false;
  }
}

// Валидация заявки на подбор
// TODO если мы хотим прикрутить сообщения об ошибках валидации полей, надо это делать через инструменты materialUI
class PartyFormValidation {
  constructor(options = {}) {
    this.opts = options;
    this.email_regexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  };

  init() {
    let this_object = this;
    // @TODO нужна ванильная маска, без нее не выпилить jquery из этого класса
    this.iti = safeInitIntlTelInput(`#${this.opts.client_phone}`, iti_config);

    $(`#${this.opts.client_phone}`).change(); // так надо
    // document.getElementById(this.opts.date_start).onchange = () => this_object.validateDates(); // Решили убрать
    document.getElementById(this.opts.client_name).onblur = () => this_object.validateName();
    document.getElementById(this.opts.client_last_name).onblur = () => this_object.validateLastName();
    document.getElementById(this.opts.client_email).onblur = () => this_object.validateEmail();
    document.getElementById(this.opts.client_phone).onblur = () => this_object.validatePhone();
    $(`#${this.opts.submit_bid_btn}`).off('click')
      .on('click', function() {
        if (this_object.validateName() &&
          this_object.validateLastName() &&
          this_object.validatePhone() &&
          this_object.validateEmail() &&
          this_object.validateCaptcha()) {
          window.ymReachGoal('party-send-metrika');
          return true;
        } else {
          return false;
        }
      });
  };

  // top: rect.top + window.scrollY,
  // left: rect.left + window.scrollX,
  scrollToObj(selector) {
    window.scrollTo({
      top: selector.getBoundingClientRect().top + window.scrollY - 20,
      behavior: "smooth"
    });
  };

  indicateError(indicate, error_element) {
    if (indicate) {
      $(error_element).closest('.mtui-text-field__wrapper').addClass('mtui-text-field_error');
    } else {
      $(error_element).closest('.mtui-text-field__wrapper').removeClass('mtui-text-field_error');
    }
    return !indicate;
  };

  validateDates() {
    let res = document.getElementById(this.opts.date_start).value.trim() === '';

    return this.indicateError(res, document.getElementById(this.opts.date_range));
  };

  validateName() {
    let res = document.getElementById(this.opts.client_name).value.trim() === '';
    return this.indicateError(res, document.getElementById(this.opts.client_name));
  };

  validateLastName() {
    let res = document.getElementById(this.opts.client_last_name).value.trim() === '';
    return this.indicateError(res, document.getElementById(this.opts.client_last_name));
  };

  validateEmail() {
    if (document.getElementById(this.opts.responsible_id).value?.length) return true;
    let email = document.getElementById(this.opts.client_email).value.trim();
    let res = email === '' || !this.email_regexp.test(email);
    return this.indicateError(res, document.getElementById(this.opts.client_email));
  };

  validatePhone() {
    let invalid = true
    if (this.iti === null || this.iti === undefined) {
      return invalid;
    }
    let expr = phone_settings[this.iti.getSelectedCountryData().iso2]['validator'];
    let phone = document.getElementById(this.opts.client_phone).value.trim();
    invalid = phone === '' || !expr.test(phone);

    return this.indicateError(invalid, document.getElementById(this.opts.client_phone));
  };

  validateCaptcha() {
    execCaptcha();
  }
}

$(document).ready(function() {
  if ((typeof menu === 'undefined') || (menu === null)) {
    $('.new-browser').toggleClass('hidden');
    $('.old-browser').toggleClass('hidden');
  }

  new DatePicker('dates', {
    dateStart: '#date_start',
    dateEnd: '#date_end',
    dateRange: '#date_range',
    firstPreview: false
  }).init();

  MTUIOnInit(() => {
    MTUIGetElement('desired_country_id').change((id) => {
      if (!id) {
        MTUIGetElement('desired_region_id').insertData([]);
        return;
      }
      $.post('/countries/get_regions', { country_id: id }, function (data) {
        MTUIGetElement('desired_region_id').insertData(JSON.parse(data));
      })
    });

    MTUIGetElement('desired_region_id').change((id) => {
      if (!id) {
        MTUIGetElement('book_camp_id').insertData([]);
        return;
      }
      $.ajax({
        url: '/regions/get_camps',
        type: 'GET',
        data: {
          region_id : id,
          only_bookable: true,
          website_type: window.website_type,
          not_test: true
        },
        success: (data) => {
          MTUIGetElement('book_camp_id').insertData(data);
        },
        error(jqXHR, textStatus, errorThrown) {
          return noty_render_alert('error', 'Ошибка! Что-то пошло не так!');
        },
        dataType: 'json'
      });
    })
  })

  $('#children_count').change(function () {
    let prev_count = $('.children_age').length;
    if ($(this).val() == 0) {
      $('.guest-child__title').hide();
    } else {
      $('.guest-child__title').show();
    }
    if ($(this).val() > prev_count) {
      for (let i = 0; i < $(this).val() - prev_count; i++) {
        $('.children_ages').append(
            `<div class="mtui-text-field__wrapper coop__input_w60 children_age mtui-text-field_filled">
                <input id="children_age" min="0" max="17" class="mtui-text-field__input" value="8" type="number" name="booking_data[children_count_arr][]">
            </div>`);
      }
      textFieldsInit();
    } else if ($(this).val() < prev_count) {
      for (let i = 0; i < prev_count - $(this).val(); i++) {
        $('.children_age').last().remove();
      }
    }
  })

  new PartyFormValidation({
    date_range: 'date_range',
    date_start: 'date_start',
    date_end: 'date_end',
    client_name: 'client_name',
    client_last_name: 'client_last_name',
    client_email: 'client_email',
    client_phone: 'client_phone',
    submit_bid_btn: 'submit_bid_btn',
    responsible_id: 'responsible_id'
  }).init();
  syncClientFormData('party');
});
